import React from 'react';
import IconComponent from '../shared/IconComponents/IconComponent';

interface ICloseExecProps {
    distanceInPx: number;
    func: () => void;
}

export const CloseExec: React.FC<ICloseExecProps> = ({ distanceInPx, func }) => {
    return (
        <button onClick={func} className="close-exec" style={{ right: `${distanceInPx}px`, top: `${distanceInPx}px` }}>
            <IconComponent size={1} iconName={'Close_exec'} />
        </button>
    );
};
